exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss"), undefined);

// module
exports.push([module.id, ".ImproveBox__improveSurround___2x9Hs {\n\tbackground-color: #eee;\n\tpadding: " + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["pagePadding"] + ";\n\tmargin: " + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["pagePadding"] + " 0;\n}\n\n.ImproveBox__icon___eEJli {\n\tmargin-right: 0.5rem;\n}\n.ImproveBox__icon___eEJli svg {\n\tcolor: " + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["primaryColour"] + ";\n}\n\n.ImproveBox__text___3bIso {\n\tfont-weight: bold;\n}\n\n.ImproveBox__header___5HCfR {\n\tdisplay: flex;\n}\n", ""]);

// exports
exports.locals = {
	"primaryColour": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["primaryColour"] + "",
	"pagePadding": "" + require("-!../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../colours.icss").locals["pagePadding"] + "",
	"improveSurround": "ImproveBox__improveSurround___2x9Hs",
	"icon": "ImproveBox__icon___eEJli",
	"text": "ImproveBox__text___3bIso",
	"header": "ImproveBox__header___5HCfR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/ImproveBox.icss
// module id = 1469
// module chunks = 0